import { useEffect, useRef, useState } from 'react'
import { SActionBtn, SDrawerOrModal, SLowcodeList, SMessage, STableActions } from 'shj-components'
import { config, configHandle } from './config'
import {
  breakManagePage,
  deleteCostTemplate,
  getCostTemplate,
  getPriceItemPage,
  getProductEnums,
  priceImportFeesBatchImport,
  priceItemDelete,
  priceItemUpdateShowFlag,
  priceItemUpdateState,
  updateCostTemplateState,
} from '@/services/product.ts'
import { apiData2Table } from '@/utils/data.ts'
import { Button, message, Switch, Upload } from 'antd'
import { useNavigate } from 'react-router-dom'
import AddOrEdit from '@/pages/priceTagManage/addOrEdit'
import BreakFeeEdit from '@/pages/priceTagManage/addOrEdit/breakManage'
import { useSetState } from 'ahooks'
import AddOrRenameModal from './modalOrDrawers/addOrRenameModal'
import CopyModal from './modalOrDrawers/copyModal'
import dayjs from 'dayjs'
import { fileDownload } from '@/utils/download'
import UrlConfig from '@/api/UrlConfigs'

export default function PriceList(props) {
  const { type } = props
  const navigate = useNavigate()
  const listRef = useRef()
  const editRef = useRef({ onFinish: undefined })

  const [state, setState] = useSetState<any>({
    open: false,
    record: {},
    btnLoading: false,
    data: [],
    exportLoading: false,
    importLoading: false,
  })
  const [feeTemplateModal, setFeeTemplateModal] = useState({
    open: false,
    isAdd: false,
    record: {},
  })
  const [copyModal, setCopyModal] = useState({
    open: false,
    record: {},
  })

  const fetchList = ({ current, pageSize, query }) => {
    if (!type) return
    return new Promise((resolve, reject) => {
      let apiPost
      switch (type) {
        case 'BREAK_MANAGE':
          apiPost = breakManagePage
          break
        case 'FEES_TEMPLATE':
          apiPost = getCostTemplate
          break
        default:
          apiPost = getPriceItemPage
      }
      apiPost({
        params: { pageId: current, pageSize },
        data: type === 'FEES_TEMPLATE' ? { ...query, searchFlag: true } : { ...query, costType: type, parentId: '0', searchFlag: true },
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setState({ open: true, record })
  }

  // 新增模版
  const onAddTemplate = () => {
    setFeeTemplateModal({ open: true, isAdd: true, record: {} })
  }

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return priceItemDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onChangeStatus = (enabled: boolean, id, key: string) => {
    let str = ''
    switch (key) {
      case 'fees':
        str = `将${enabled ? '启用' : '禁用'}费用项`
        break
      case 'showFlag':
        str = `费用项状态变更为${enabled ? '' : '不'}显示`
        break
      case 'template':
        str = `将${enabled ? '启用' : '禁用'}费用模板`
        break
      default:
        str = ''
    }
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，${str}，是否继续？`,
      content: null,
      okText: '继续',
      onOk: () => {
        let spiUrl
        switch (key) {
          case 'fees':
            spiUrl = priceItemUpdateState
            break
          case 'showFlag':
            spiUrl = priceItemUpdateShowFlag
            break
          case 'template':
            spiUrl = updateCostTemplateState
            break
          default:
            spiUrl = () => Promise.resolve()
        }
        return spiUrl({ idList: [id], enabled }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onConfig = record => {
    navigate(
      '/config/priceTagManage/specialConfig/' +
        record.id +
        `?name=${record.itemName}&mathType=${record.mathType}&hasParent=${record.parentId != '0'}&type=${type}`
    )
  }

  const onSubmit = () => {
    editRef.current?.onFinish?.()
  }

  const getStatusOptions = async () => {
    const statueEnum = await getProductEnums('com.shj.saas.plus.product.enums.StatueEnum')
    return Promise.resolve({ statueEnum })
  }

  const onImportPage = record => {
    console.log(record, 'record')
    if (record.feeImportTypeEnum !== 'PRICE_LIMIT') {
      navigate(
        '/config/priceTagManage/importConfig/' + record.id + `?name=${record.itemName}&type=${type}`
      )
    } else {
      navigate(
        '/config/priceTagManage/limitImportConfig/' + record.id + `?name=${record.itemName}&type=${type}`
      )
    }
  }

  // 删除模版
  const deleteTemplate = id => {
    SMessage.confirm({
      title: '提示',
      content: '确定删除该模板吗？',
      onOk: () => {
        deleteCostTemplate(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }
 const onExport = () => {
    setState({ exportLoading: true })
    fileDownload(UrlConfig.PlusProductWeb.PriceImportFeesBatchExport,{
      method:'POST'
    })
     .then(() => setState({ exportLoading: false }))
      .catch(() => setState({ exportLoading: false }))
  }
  const onImport = (upload: any) => {
    setState({ importLoading: true })
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    return priceImportFeesBatchImport(data)
        .then((res: any) => {
          listRef.current && listRef.current.reload()
          onSuccess && onSuccess()
          message.success(res.message || '导入成功')
        })
        .catch(onError)
        .finally(() => setState({ importLoading: false }))
  }
  const extensions = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onAddTemplate },
    status: {
      selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return !Number(record.parentId) ? (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
            checked={v}
            onClick={checked => onChangeStatus(checked, record.id, 'fees')}
          />
        ) : (
          ''
        )
      },
      switchRender1(v: boolean, record: Record<string, any>) {
        return Number(record.parentId) ? (
          <Switch
            checkedChildren="是"
            unCheckedChildren="否"
            checked={v}
            onClick={checked => onChangeStatus(checked, record.id, 'showFlag')}
          />
        ) : (
          ''
        )
      },
      templateSwitchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
            checked={v}
            onClick={checked => onChangeStatus(checked, record.id, 'template')}
          />
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            {record.mathType === 'IMPORT_DATA' && (
              <SActionBtn onClick={() => onImportPage(record)}>导入费用</SActionBtn>
            )}
            {record.mathType !== 'IMPORT_DATA' && (
              <SActionBtn onClick={() => onConfig(record)}>特殊配置</SActionBtn>
            )}
            {!Number(record.parentId) && (
              <SActionBtn
                onClick={() => onEdit({ parentId: record.id, initFlag: record.initFlag })}
              >
                添加明细
              </SActionBtn>
            )}
            {!record.initFlag && (
              <SActionBtn danger onClick={() => onDel(record.id)}>
                删除
              </SActionBtn>
            )}
          </STableActions>
        )
      },
      breakManageActionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
          </STableActions>
        )
      },
      feesTemplateActionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn
              onClick={() =>
                setFeeTemplateModal({
                  open: true,
                  isAdd: false,
                  record,
                })
              }
            >
              重命名
            </SActionBtn>
            <SActionBtn
              onClick={() =>
                navigate(`/config/priceTagManage/templateDetail/${record.id}/${record.templateName}`)
              }
            >
              模板配置
            </SActionBtn>
            <SActionBtn onClick={() => setCopyModal({ open: true, record })}>复制</SActionBtn>
            {!record?.enabled && (
              <SActionBtn danger onClick={() => deleteTemplate(record.id)}>
                删除
              </SActionBtn>
            )}
          </STableActions>
        )
      },
      sortRender(v, r, s) {
        return s + 1
      },
      createdTimeRender(_, record: Record<string, any>) {
        return record.createdTime ? dayjs(record.createdTime).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={state.importLoading}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            onClick={onExport}
            disabled={state.exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
    },
  }
  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={configHandle(type)} {...extensions} />
      <SDrawerOrModal
        title={(state.record.id ? '编辑' : '新增') + '费用项'}
        mode={props.type !== 'BREAK_MANAGE' ? 'drawer' : "modal"}
        open={state.open}
        loading={state.btnLoading}
        onCancel={() => setState({ open: false, record: {} })}
        onOk={onSubmit}
        width={props.type !== 'BREAK_MANAGE' ? 600 : 500}
      >
        {state.open &&
          (props.type !== 'BREAK_MANAGE' ? (
            <AddOrEdit
              editRef={editRef.current}
              record={state.record}
              onCancel={() => setState({ open: false, record: {} })}
              fn={listRef.current?.reload}
              type={type}
              setLoading={(btnLoading: boolean) => setState({ btnLoading })}
            />
          ) : (
            <BreakFeeEdit
              editRef={editRef.current}
              record={state.record}
              onCancel={() => setState({ open: false, record: {} })}
              fn={listRef.current?.reload}
              type={type}
              setLoading={(btnLoading: boolean) => setState({ btnLoading })}
            ></BreakFeeEdit>
          ))}
      </SDrawerOrModal>
      <AddOrRenameModal
        open={feeTemplateModal.open}
        onCancel={() => setFeeTemplateModal({ ...feeTemplateModal, open: false, record: {} })}
        isAdd={feeTemplateModal.isAdd}
        clickInfo={feeTemplateModal.record}
        listRef={listRef}
      />
      <CopyModal
        listRef={listRef}
        open={copyModal.open}
        record={copyModal.record}
        onCancel={() => setCopyModal({ open: false, record: {} })}
      />
    </div>
  )
}
